var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalUi',{on:{"closeModal":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"white-block modal-block default-modal"},[_c('div',{staticClass:"title"},[_c('h3',[_vm._t("modal-title")],2)]),_c('div',{staticClass:"cause"},[_vm._t("modal-body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }